// extracted by mini-css-extract-plugin
module.exports = {"pip":"menuicon_pip__1kvcX","active":"menuicon_active__2D9iZ","menu":"menuicon_menu__15BlV","cross":"menuicon_cross__36tF5"};